'use strict';

import { AncillariesLimitations } from './passenger-flight-info.model';

export class Passenger {
	id: string;
	firstName: string;
	lastName: string;
	date_of_birth: Date;
	title?: string;
	contactPhone?: {
		countryCode: string;
		number: string;
		preferred: string;
		prefix: string;
		phoneType?: string;
	};
	contactEmail; string;

	gender: PassengerGender;
	redressNumber: string;

	private _primary: boolean;
	type: PassengerAgeSegment;
	typeCount: number;

	ticket_number: string;

	frequentFlyer: {
		program: string,
		number: string,
		tierLevel: 'miles' | 'silver' | 'gold' | 'navigator' | 'other'
	};

	emergencyContact: {
		no_contact: boolean,
		name: string,
		country: string,
		phone_prefix: string,
		phone_number: number
	};

	personalDocuments: {
		type: string,
		number: string,
		expiration_date: Date,
		lifelong: boolean,
		issuing_country: string,
		nationality: string,
		date_of_birth: Date
	};

	addressInUSA: {
		state: string,
		address: string,
		zip_code: string,
		city: string,
		redress_number: string
	};

	studentFare: {
		document_number: number,
		fiscal_number: number,
		confirm: boolean
	};

	contacts: {
		email: string,
		type: string,
		country: string,
		number: string
	};

	ancillaries_limitations?: AncillariesLimitations;

	work_travel: {
		is_work_travel: string
	};

	missing_info: any;
	warnings: Array<string>;
	airlineID: string;

	constructor(type?: PassengerAgeSegment, primary = false) {
		this.type = type;
		this._primary = primary;
	}


	get name() {
		return this.firstName && this.lastName ? (`${this.firstName} ${this.lastName}`) : false;
	}

	get formattedType(): string {
		return this.type.toLocaleUpperCase();
	}

	get formattedName(): string {
		return this.name ? this.name : this.formattedType;
	}

	get isPrimary(): boolean {
		return this._primary;
	}

	set primary(val: boolean) {
		this._primary = val;
	}

	get missingInfo() {
		const result = [];

		if (this.missing_info) result.concat(this.missing_info);
		
		/*
		if (
			!this.emergencyContact ||
			(
				!this.emergencyContact.no_contact &&
				(!this.emergencyContact.name || !this.emergencyContact.country || !this.emergencyContact.phone_prefix || !this.emergencyContact.phone_number)
			)
		) {
			result.push('emergencyContact');
		}
		*/
		if (
			!this.personalDocuments ||
			!this.personalDocuments.type ||
			!this.personalDocuments.number ||
			(!this.personalDocuments.lifelong && !this.personalDocuments.expiration_date) ||
			!this.personalDocuments.issuing_country ||
			!this.personalDocuments.nationality ||
			!this.personalDocuments.date_of_birth
		) {
			result.push('personalDocuments');
		}

		/*if (!this.addressInUSA ||
			!this.addressInUSA.state ||
			(
				this.addressInUSA.state !== 'outside_usa' &&
				(!this.addressInUSA.address || !this.addressInUSA.zip_code || !this.addressInUSA.city)
			)
		) {
			result.push('addressInUSA');
		}
*/
		if (!this.studentFare || !this.studentFare.document_number || !this.studentFare.fiscal_number || !this.studentFare.confirm) {
			result.push('studentFare');
		}
		return result;
	}
}

export type PassengerAgeSegment = 'adult' | 'youngAdult' | 'child' | 'infant';
export type PassengerGender = 'male' | 'female';
export interface PassengersSegmentedCount {
	children: number;
	adults: number;
	youngAdults: number;
	infants: number;
}
